import permissions from "./permissions/state";

const apps = {
    ...permissions,
    appsNumber: 0,
    apps: [],
    pagedApps: [],
    staticAppIdsList: [],
    currentApp: {},
    currentProcess: {},
    processList: [],
    appDDL: [],
    path: {},
    currentNrOfApps: 0,
    hasMore: true,
    appWasArchived: false,
    diagramExternalPluginList: {
        activities: [],
        events: [],
        gateways: []

    }
};

export default apps;
